module.exports = __webpack_public_path__ + "media/src/images/top_covers/2021_mar_01-7d337b61035b7d29cabddbb72d0a452a.png";